<template>
  <footer class="border-t border-gray-200 bg-white/50 backdrop-blur-sm">
    <div class="container mx-auto px-4 py-8">
      <div class="grid md:grid-cols-4 gap-8">
        <!-- Logo和描述 -->
        <div>
          <div class="flex items-center gap-2 mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-primary">
              <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path>
            </svg>
            <span class="font-bold text-psychology-primary">RPI Calculator</span>
          </div>
          <p class="text-sm text-gray-600">
            基于心理学研究的恋爱占有欲指数计算器，帮助您更好地了解恋爱关系中的占有欲特点。
          </p>
        </div>

        <!-- 评估工具 -->
        <div>
          <h4 class="font-semibold mb-3">评估工具</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <button class="hover:text-psychology-primary cursor-pointer">给自己测</button>
            </li>
            <li>
              <button class="hover:text-psychology-primary cursor-pointer">为恋人测</button>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">历史记录</a>
            </li>
          </ul>
        </div>

        <!-- 资源 -->
        <div>
          <h4 class="font-semibold mb-3">资源</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <a href="#" class="hover:text-psychology-primary">使用指南</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">科学依据</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">隐私政策</a>
            </li>
          </ul>
        </div>

        <!-- 支持 -->
        <div>
          <h4 class="font-semibold mb-3">支持</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <a href="#" class="hover:text-psychology-primary">常见问题</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">专业咨询</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">危机资源</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
        <p>© 2025 恋爱占有欲指数计算器. 仅供教育和自我了解使用，不能替代专业心理健康服务。</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

